import FreeFloatChart from "components/charts/modern/FreeFloatChart";
import SharesChart from "components/charts/modern/SharesChart";
import SharesholdersChart from "components/charts/modern/SharesholdersChart";
import TradesChart from "components/charts/modern/TradesChart";
import {
  CompanyContainer,
  CompanyContentContainer,
  CompanyTabsContent,
  CompanyTabsList,
} from "components/company/v3/CompanyContainers";
import { CompanyLiquidityTabEnum } from "components/company/v3/menu/enums";
import { Tabs } from "components/ui/Tabs";
import { AreaChartIcon, BarChart3Icon, PercentIcon } from "lucide-react";
import { useIntl } from "react-intl";

interface AmericanLiquidityBoxProps {
  tickerSymbol: string;
  tab: CompanyLiquidityTabEnum;
  onChangeTab: (tab: CompanyLiquidityTabEnum) => void;
}

export default function AmericanLiquidityBox({ tickerSymbol, tab, onChangeTab }: AmericanLiquidityBoxProps) {
  const intl = useIntl();

  return (
    <CompanyContainer>
      <CompanyContentContainer>
        <Tabs
          defaultValue={CompanyLiquidityTabEnum.TRADE_HISTORY}
          value={tab}
          onValueChange={(value) => onChangeTab(value as CompanyLiquidityTabEnum)}
          className="h-full w-full"
        >
          <CompanyTabsList
            activeTab={tab}
            tabs={[
              {
                value: CompanyLiquidityTabEnum.TRADE_HISTORY,
                label: intl.formatMessage({
                  defaultMessage: "Volume",
                  description: "Aba do menu superior da empresa",
                  id: "1aZOi1",
                }),
                icon: <BarChart3Icon className="inline-flex" size={16} strokeWidth={2} />,
              },
              {
                value: CompanyLiquidityTabEnum.SHARES_OUTSTANDING,
                label: intl.formatMessage({
                  defaultMessage: "Ações em Circulação",
                  description: "Aba do menu superior da empresa",
                  id: "IPt9zK",
                }),
                icon: <AreaChartIcon className="inline-flex" size={16} strokeWidth={2} />,
              },
              {
                value: CompanyLiquidityTabEnum.FREE_FLOAT,
                label: intl.formatMessage({
                  defaultMessage: "Free Float",
                  description: "Aba do menu superior da empresa",
                  id: "9pJqwP",
                }),
                icon: <PercentIcon className="inline-flex" size={16} strokeWidth={2} />,
              },
            ]}
          />

          <CompanyTabsContent value={CompanyLiquidityTabEnum.TRADE_HISTORY}>
            <TradesChart tickerSymbols={[tickerSymbol]} />
          </CompanyTabsContent>

          <CompanyTabsContent value={CompanyLiquidityTabEnum.SHARES_OUTSTANDING}>
            <SharesChart tickerSymbols={[tickerSymbol]} />
          </CompanyTabsContent>

          <CompanyTabsContent value={CompanyLiquidityTabEnum.FREE_FLOAT}>
            <FreeFloatChart tickerSymbols={[tickerSymbol]} />
          </CompanyTabsContent>

          <CompanyTabsContent value={CompanyLiquidityTabEnum.SHARES_HOLDERS}>
            <SharesholdersChart tickerSymbols={[tickerSymbol]} />
          </CompanyTabsContent>
        </Tabs>
      </CompanyContentContainer>
    </CompanyContainer>
  );
}
